<div
  class="flex md:flex-row justify-center w-full items-center h-full min-h-screen gap-[66px] flex-col"
>
  <div class="flex flex-col items-center content-center w-[294px] gap-4">
    @if(this.renderData().isDisplay404) {
      <h1 class="font-bold text-[80px] primary-blue pb-4 text-[var(--primary-blue)]">404</h1>
    }
    <div>
      <p class="text-center font-bold">{{this.renderData().headline}}</p>
      <p class="text-center mb-2">
        {{this.renderData().explanatoryText}}
      </p>
    </div>
    <a (click)="navigate()" class="text-[var(--tag-color)] cursor-pointer" target="_blank" rel="noopener noreferrer">
      {{this.renderData().actionOrientLink.name}}
      <img
        class="inline-block"
        src="../../../../../assets/ui-ic-right-small.svg"
        alt="error-page"
      />
    </a>
  </div>

  <img class="h-[200px] md:h-full" src="../../../../../assets/Error-page.svg" alt="error-page" />
</div>